import AnimatedNumber from 'animated-number-react';
import { useTranslation } from 'react-i18next';

import { SRBMDetailData } from 'api/traps/SRBMTraps/types';
import CustomPlaceholder from 'components/Utils/CustomPlaceHolder';

interface WorkTImeCardProps {
  data: SRBMDetailData | null;
  isLoading: boolean;
}

const WorkTimeCard: React.FC<WorkTImeCardProps> = ({ data, isLoading }) => {
  const { t } = useTranslation();
  const formatNumber = (number: number): string => {
    return number.toLocaleString('en-US').replace(/,/g, ' ');
  };

  return (
    <div className="card card-animate shadow-lg ">
      <div className="card-body">
        <div className="d-flex justify-content-between">
          <div>
            <p className="fw-medium fs-14 text-muted mb-0">{t('SBSDetail.infoCardsRow.workTime')}</p>
            <h2 className="mt-4 ff-secondary fw-semibold placeholder-glow text-center">
              <h5>
                <span>
                  {isLoading ? (
                    <CustomPlaceholder colSize={12} />
                  ) : (
                    <span>
                      <AnimatedNumber
                        value={data?.work_time ? +data.work_time : 0}
                        formatValue={formatNumber}
                        duration={1000}
                        className="animated-number"
                      />{' '}
                      {t('SBSDetail.infoCardsRow.days')}
                    </span>
                  )}
                </span>
              </h5>
            </h2>
          </div>
          <div>
            <div className="avatar-sm flex-shrink-0">
              <span>
                <lord-icon
                  src="https://cdn.lordicon.com/kbtmbyzy.json"
                  trigger="loop"
                  colors="primary:#405189,secondary:#02a8b5"
                  style={{ width: '60px', height: '60px' }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkTimeCard;
